import { render, staticRenderFns } from "./ExtraList.vue?vue&type=template&id=7e5580a0&scoped=true&"
import script from "./ExtraList.vue?vue&type=script&lang=js&"
export * from "./ExtraList.vue?vue&type=script&lang=js&"
import style0 from "./ExtraList.vue?vue&type=style&index=0&id=7e5580a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5580a0",
  null
  
)

export default component.exports